/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderLineDto } from './OrderLineDto';
import {
    OrderLineDtoFromJSON,
    OrderLineDtoFromJSONTyped,
    OrderLineDtoToJSON,
} from './OrderLineDto';

/**
 * 
 * @export
 * @interface CartDto
 */
export interface CartDto {
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    updated: string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    locationId: string;
    /**
     * 
     * @type {Array<OrderLineDto>}
     * @memberof CartDto
     */
    orderLines: Array<OrderLineDto>;
    /**
     * 
     * @type {number}
     * @memberof CartDto
     */
    totalPrice: number;
    /**
     * 
     * @type {number}
     * @memberof CartDto
     */
    totalTakeawayPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    paymentMethod?: string;
    /**
     * 
     * @type {number}
     * @memberof CartDto
     */
    discountId?: number;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    vatType: CartDtoVatTypeEnum;
}


/**
 * @export
 */
export const CartDtoVatTypeEnum = {
    TAKEAWAY: 'TAKEAWAY',
    EAT_IN: 'EAT_IN'
} as const;
export type CartDtoVatTypeEnum = typeof CartDtoVatTypeEnum[keyof typeof CartDtoVatTypeEnum];


/**
 * Check if a given object implements the CartDto interface.
 */
export function instanceOfCartDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "orderLines" in value;
    isInstance = isInstance && "totalPrice" in value;
    isInstance = isInstance && "vatType" in value;

    return isInstance;
}

export function CartDtoFromJSON(json: any): CartDto {
    return CartDtoFromJSONTyped(json, false);
}

export function CartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created': json['created'],
        'updated': json['updated'],
        'status': json['status'],
        'locationId': json['locationId'],
        'orderLines': ((json['orderLines'] as Array<any>).map(OrderLineDtoFromJSON)),
        'totalPrice': json['totalPrice'],
        'totalTakeawayPrice': !exists(json, 'totalTakeawayPrice') ? undefined : json['totalTakeawayPrice'],
        'paymentMethod': !exists(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'discountId': !exists(json, 'discountId') ? undefined : json['discountId'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'vatType': json['vatType'],
    };
}

export function CartDtoToJSON(value?: CartDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created': value.created,
        'updated': value.updated,
        'status': value.status,
        'locationId': value.locationId,
        'orderLines': ((value.orderLines as Array<any>).map(OrderLineDtoToJSON)),
        'totalPrice': value.totalPrice,
        'totalTakeawayPrice': value.totalTakeawayPrice,
        'paymentMethod': value.paymentMethod,
        'discountId': value.discountId,
        'comment': value.comment,
        'vatType': value.vatType,
    };
}

